import Box from '@mui/material/Box'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import FlatLayout from '../../../components/layouts/flatLayout'
import { securityFieldApi } from '../../../hooks/api/securityField'
import { SecurityField } from '../../../types/securityField'

const apiCall = {
  securityFields: async () => {
    const response = await securityFieldApi().filter()
    return response.data
  },
}

export default function ShiftListPage() {
  const navigate = useNavigate()
  const [securityFields, setSecurityFields] = useState<SecurityField[]>([])

  useEffect(() => {
    apiCall.securityFields().then((data) => {
      setSecurityFields(data)
    })
  }, [])

  const clickSecurityFieldHandler = (securityField: SecurityField) => {
    return () => navigate(`/shift/show/${securityField.id}`)
  }

  return (
    <FlatLayout title={'シフト'}>
      {securityFields.map((securityField) => (
        <Box
          key={securityField.id}
          sx={{
            borderBottom: '1px solid #ccc',
            padding: '8px',
            '&:hover': {
              backgroundColor: '#eee',
            },
          }}
          onClick={clickSecurityFieldHandler(securityField)}
        >
          {securityField.name}
        </Box>
      ))}
    </FlatLayout>
  )
}
